import React, { useState, useEffect } from 'react';
import { Typography, Box } from '@mui/material';

interface LiveClockProps {
  timezone: string;
  label: string;
}

export default function LiveClock({ timezone, label }: LiveClockProps) {
  const [time, setTime] = useState('');

  useEffect(() => {
    const update = () => {
      const now = new Date();
      try {
        setTime(now.toLocaleTimeString('en-US', {
          timeZone: timezone,
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: true,
        }));
      } catch {
        setTime(now.toLocaleTimeString('en-US'));
      }
    };
    update();
    const interval = setInterval(update, 1000);
    return () => clearInterval(interval);
  }, [timezone]);

  return (
    <Box sx={{ textAlign: 'center', mx: 1.5 }}>
      <Typography variant="caption" sx={{ display: 'block', opacity: 0.7, lineHeight: 1 }}>
        {label}
      </Typography>
      <Typography variant="body2" sx={{ fontFamily: 'monospace', fontWeight: 600, lineHeight: 1.4 }}>
        {time}
      </Typography>
    </Box>
  );
}
